(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-tabs')) {
    customElements.define(
      'product-tabs',
      class ProductTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
          this.addEventListener('click', this.handleClick);
          this.addEventListener('keydown', this.handleKeydown);
        }
        disconnectedCallback() {
          this.removeEventListener('click', this.handleClick);
          this.removeEventListener('keydown', this.handleKeydown);
        }
        handleClick = (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (!tab || !this.contains(tab)) return;
          this.select(tab);
        };
        handleKeydown = (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (!tab || !this.contains(tab)) return;
          const total = this.tabs.length;
          const i = this.tabs.indexOf(tab);
          let next = null;
          if (event.key === 'ArrowRight') next = this.tabs[(i + 1) % total];
          else if (event.key === 'ArrowLeft') next = this.tabs[(i - 1 + total) % total];
          else if (event.key === 'Home') next = this.tabs[0];
          else if (event.key === 'End') next = this.tabs[total - 1];
          if (!next) return;
          event.preventDefault();
          this.select(next);
          next.focus();
        };
        select(tab) {
          const name = tab.dataset.tab;
          for (const item of this.tabs) {
            const on = item === tab;
            item.setAttribute('aria-selected', on ? 'true' : 'false');
            item.tabIndex = on ? 0 : -1;
          }
          for (const panel of this.panels) {
            panel.hidden = panel.dataset.panel !== name;
          }
          window.dispatchEvent(new Event('resize'));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
